import React from "react";

type Props = {
    icon: React.ReactNode;
    title: string;
    comingSoon?: boolean;
    callback?: any;
}
const DashboardSections = ({ icon, title, comingSoon, callback }: Props) => {
    return (
        <div
            className={`col-span-1 ${!comingSoon ? "bg-indigo-100 hover:bg-indigo-300  cursor-pointer" : "opacity-50"} p-4 rounded-xl h-[550px] border-gray-200 border-2`}
            aria-disabled={true}
            onClick={() => {
                if (comingSoon) return;

                callback();
            }}
        >
            <div className="h-[50%] p-4">
                {icon}
            </div>

            <div className="h-[50%] ps-4 flex flex-col">
                <h1 className="text-5xl">{title}</h1>
                {comingSoon && <span className="text-gray-500">(coming soon)</span>}
            </div>
        </div>
    );
};

export default DashboardSections;